import { Box, Typography } from "@mui/material";
import { formatPaymentStatusLabel } from "../../utils/orderDisplayStatus";

const PAYMENT_STATUS_COLORS = {
  paid: { bg: "#00C046", color: "#fff" },
  pending: { bg: "#FF8500", color: "#fff" },
  failed: { bg: "#FF3850", color: "#fff" },
  refunded: { bg: "#126ABC", color: "#fff" },
  unpaid: { bg: "#FF3850", color: "#fff" },
  partial_paid: { bg: "#7B61FF", color: "#fff" },
};

function getPaymentPalette(paymentStatus) {
  const key = String(paymentStatus ?? "").trim().toLowerCase();
  return PAYMENT_STATUS_COLORS[key] ?? { bg: "#9C9C9C", color: "#fff" };
}

export function getPaymentStatusLabel(paymentStatus) {
  return formatPaymentStatusLabel(paymentStatus);
}

export default function OrderPaymentStatus({ paymentStatus }) {
  const label = getPaymentStatusLabel(paymentStatus);
  const palette = getPaymentPalette(paymentStatus);

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        whiteSpace: "nowrap",
      }}
    >
      <Typography
        component="span"
        variant="caption"
        color="text.secondary"
        fontWeight={600}
        sx={{ letterSpacing: "0.02em" }}
      >
        Payment
      </Typography>
      <Box
        component="span"
        sx={{
          display: "inline-block",
          px: 1.25,
          py: 0.35,
          borderRadius: "20px",
          bgcolor: palette.bg,
          color: palette.color,
          fontSize: "0.7rem",
          fontWeight: 700,
          lineHeight: 1.2,
          textTransform: "capitalize",
        }}
      >
        {label}
      </Box>
    </Box>
  );
}
